import { c as _c } from "react/compiler-runtime";
import { CouponEntity } from '../../../../domain/entry.js';
import { useEngine } from '../../engine/hooks/useEngine.js';
import { useSubscribedCoupon } from './useSubscribedCoupon.js';
/**
 * Calculates the current coupon status based on its state.
 *
 * @param root0 Hook arguments
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndex Specific coupon id in order
 * @returns Current status of the coupon
 */
export function useCouponStatus(t0) {
  const $ = _c(6);
  const {
    couponId,
    couponIndex
  } = t0;
  const definition = useEngine();
  let t1;
  if ($[0] !== definition) {
    t1 = coupon => {
      if (!coupon) {
        return "INVALID_NOT_STARTED";
      }
      return CouponEntity.getStatus(coupon, {
        definition: definition.model
      });
    };
    $[0] = definition;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== couponId || $[3] !== couponIndex || $[4] !== t1) {
    t2 = {
      couponId,
      couponIndex,
      selector: t1
    };
    $[2] = couponId;
    $[3] = couponIndex;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const couponStatus = useSubscribedCoupon(t2);
  return couponStatus;
}